module.exports = __webpack_public_path__ + "static/media/photo_hotspot.381c80cb.png";